import React from 'react'
import { Typography } from '@mui/material'
function ErrorMessage(props) {
    return (
        <div>
            <Typography variant="h5" color="primary"
              component="div" >
            {props.title}
          </Typography>
        </div>
    )
}

export default ErrorMessage
